<template>
    <section id="content-page">
        <slot></slot>
    </section>
</template>

<script>

export default {
    name: 'Content',
    props: {},
}
</script>

<style scoped>
    #content-page{
        background-color: #edf2f6;
        padding: 35px 40px;
        margin-left: 180px;
        min-height: 100vh;
    }
</style>